import React from 'react';

const MODES = [
    {
        value: 'none',
        title: 'No Shipping Fee',
        description: 'Include the cost in your product price.',
    },
    {
        value: 'flat',
        title: 'Flat Rate',
        description: 'You set one price for everyone.',
    },
    {
        value: 'calculated',
        title: 'Calculated',
        description: 'We look up live rates by ZIP code.',
    },
    {
        value: 'pickup',
        title: 'Local Pickup',
        description: 'In-person only, no shipping.',
    },
];

export default function ModeStep({ state, setField }) {
    const handleModeChange = (mode) => {
        if (mode === 'calculated') {
            const genericMethods = ['GENERIC_GROUND', 'GENERIC_PRIORITY', 'GENERIC_EXPRESS', 'GENERIC_OVERNIGHT'];
            setField('methods', (state.methods || []).filter((method) => !genericMethods.includes(method)));
        }
        setField('mode', mode);
    };

    return (
        <div className="shipping-step">
            <h3>Choose Shipping Pricing</h3>
            <div className="shipping-card-grid">
                {MODES.map((mode) => {
                    const selected = state.mode === mode.value;
                    return (
                        <button
                            key={mode.value}
                            type="button"
                            className={`shipping-choice-card${selected ? ' selected' : ''}`}
                            onClick={() => handleModeChange(mode.value)}
                            aria-pressed={selected}
                        >
                            <strong>{mode.title}</strong>
                            <span>{mode.description}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
